import { connect } from 'react-redux';
import { selectors, actions } from '../Stream';
const mapStateToProps = (state, { streamId  })=>({
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        hasError: !!selectors.getErrorMsg(state, streamId),
        isEmpty: (selectors.getItems(state, streamId) || []).length === 0
    });
const mapDispatchToProps = {
    fetchMore: actions.fetchNext
};
export default connect(mapStateToProps, mapDispatchToProps);
